module.exports = __webpack_public_path__ + "static/media/BANNER - QR code_V6.1b735fc5.jpg";